import { type InputHTMLAttributes } from 'react';

interface TextInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label?: string;
  error?: string | null;
  onChange?: (args: { value: string }) => void;
}

export function TextInput({ label, error, onChange, className = '', ...props }: TextInputProps) {
  return (
    <div className="flex flex-col gap-1">
      {label && <label className="text-xs font-medium text-slate-600">{label}</label>}
      <input
        {...props}
        onChange={(e) => onChange?.({ value: e.target.value })}
        className={`border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition ${error ? 'border-red-300' : ''} ${className}`}
      />
      {error && <span className="text-xs text-red-600">{error}</span>}
    </div>
  );
}
